import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { OrderVersionPreference } from 'shared/const/orderVersionPreference';
import { readOrderVersionPreferenceFromStorage } from 'shared/lib/orderVersionPreference/orderVersionPreferenceStorage';

import { OrderVersionPreferenceSchema } from '../types/OrderVersionPreferenceSchema';

const initialState: OrderVersionPreferenceSchema = {
    preference: readOrderVersionPreferenceFromStorage(),
};

export const OrderVersionPreferenceSlice = createSlice({
    name: 'orderVersionPreference',
    initialState,
    reducers: {
        setPreference: (
            state,
            action: PayloadAction<OrderVersionPreference>,
        ) => {
            state.preference = action.payload;
        },
    },
});

export const { actions: orderVersionPreferenceActions } =
    OrderVersionPreferenceSlice;
export const { reducer: orderVersionPreferenceReducer } =
    OrderVersionPreferenceSlice;
